module.exports = __webpack_public_path__ + "static/media/ron.047b0396.gif";